'use strict';

module.exports = require('./is-implemented')() ? Symbol : require('./polyfill');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es6-symbol/index.js
// module id = 487
// module chunks = 0